// ABOUTME: Workflow edit route. Renders WorkflowEditPage once the workflow is loaded.

import { Button } from "@/components/ui/button";
import { WorkflowEditPage } from "@/components/workflows/WorkflowEditPage";
import { supabase } from "@/contexts/AuthContext";
import { useWorkflows } from "@/hooks/useWorkflows";
import {
  createFileRoute,
  redirect,
  useNavigate,
  useParams,
} from "@tanstack/react-router";
import { jwtDecode } from "jwt-decode";
import { ChevronLeft } from "lucide-react";

interface JWTPayload {
  user_role?: string;
}

export const Route = createFileRoute(
  "/_authenticated/skills/workflows/$workflowId",
)({
  beforeLoad: async () => {
    const {
      data: { session },
    } = await supabase.auth.getSession();
    if (!session?.access_token) {
      throw redirect({ to: "/login" });
    }
    const decoded = jwtDecode<JWTPayload>(session.access_token);
    if (decoded.user_role !== "superadmin") {
      throw redirect({ to: "/skills" });
    }
  },
  component: WorkflowEditRouteComponent,
});

function WorkflowEditRouteComponent() {
  const { workflowId } = useParams({
    from: "/_authenticated/skills/workflows/$workflowId",
  });
  const navigate = useNavigate();
  const { data: workflows = [], isLoading } = useWorkflows();
  const wf = workflows.find((w) => w.id === workflowId);

  if (isLoading) {
    return (
      <div className="flex flex-1 items-center justify-center text-sm text-muted-foreground">
        Loading workflow…
      </div>
    );
  }
  if (!wf) {
    return (
      <div className="flex flex-1 flex-col items-center justify-center gap-4 p-10 text-center">
        <p className="text-sm text-muted-foreground">Workflow not found.</p>
        <Button
          variant="outline"
          onClick={() => void navigate({ to: "/skills/workflows" })}
        >
          <ChevronLeft className="h-4 w-4" />
          Back to workflows
        </Button>
      </div>
    );
  }

  return <WorkflowEditPage wf={wf} />;
}
